import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Top_Header from "./Top_Header";
import Header from "./Header";
import About_p from "./About_p";
import Footer from "./Footer";
import ImageSlider from './ImageSlider'
import StickyComponent from "./Sticky_component";
import { paymentContext } from "./context";

function PaymentFailure() {
  const navigate = useNavigate()
  const {paymentInfo,setPaymentInfo,isPaymentOnProgress,setIsPaymentOnProgress} = useContext(paymentContext)
  useEffect(() => {
    if(isPaymentOnProgress === false){
      navigate('/');
      return;
    }
    setPaymentInfo(null);
    setIsPaymentOnProgress(false);
    setTimeout(() => {
      navigate('/')
    }, 5000)
  }, [])
  return (
       <>
       <Top_Header />
       <Header />
       <ImageSlider></ImageSlider>
       <div style={{
         display: 'flex',
         justifyContent: 'center',
         alignItems: 'center',
         width: '70vw',
         backgroundColor: '#f50f14',
         color: 'white',
         margin: 'auto',
         marginTop: '5%',
         padding: '1%',
         justifyContent: 'center',
         borderRadius: '0.5rem',
         textAlign: 'center'
       }}>
         <h1>Your Payment Has Failed, Please Try Again</h1>
       </div>
 
       {
         <img src='https://khoslaslider.s3.ap-south-1.amazonaws.com/image/Kosla-Mascot.png' className='khosla_da_img' onClick={() => window.open(
           'https://api.whatsapp.com/send/?phone=919674425425&text&type=phone_number&app_absent=0',
           '_blank'
         )} />
       }
       <About_p />
       <Footer />
       <StickyComponent />
     </>
  );
}

export default PaymentFailure;